import React from 'react'
// @ts-ignore
import { Pill, Tag as TagIcon } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'

type TagProps = {
  text: string
}

const Tag = ({ text }: TagProps) => {
  const theme = useDisplayTheme() as Theme
  const fontSize = 16

  return (
    <Pill mode={theme}>
      <TagIcon mode={theme} fontSize={fontSize} />
      {text}
    </Pill>
  )
}

export default Tag
